import * as yup from "yup";

export const WhatsAppTemplateDetailsSchema = yup.object().shape({
  templateName: yup.string(),
  templateLabel: yup.string(),
  templateHitCondtion: yup.string(),
  isActive: yup.boolean(),
  description: yup.string(),
});
